<template>
  <div>
    <div class="main__header">
      <div class="tabs-container" style="padding-top: 30px">
        <router-link :to="{ name: routes.ROUTE_PACS_PERIMETER_SECURITY_ANALYTICS }" class="tabs-container__tab-item">
          Вторжение в зону
        </router-link>
        <router-link :to="{ name: routes.ROUTE_PACS_PEOPLE_COUNT_ANALYTICS }" class="tabs-container__tab-item">
          Подсчет посетителей
        </router-link>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
import {
  ROUTE_PACS_CAR_NUMBER_ANALYTICS,
  ROUTE_PACS_HELMET_ANALYTICS,
  ROUTE_PACS_MASK_ANALYTICS,
  ROUTE_PACS_PEOPLE_COUNT_ANALYTICS, ROUTE_PACS_PERIMETER_SECURITY_ANALYTICS,
} from "@/router/names.js";

export default {
  name: "PacsAnalyticsSettingsFrame",
  data() {
    return {
      routes: {
        ROUTE_PACS_CAR_NUMBER_ANALYTICS,
        ROUTE_PACS_HELMET_ANALYTICS,
        ROUTE_PACS_MASK_ANALYTICS,
        ROUTE_PACS_PEOPLE_COUNT_ANALYTICS,
        ROUTE_PACS_PERIMETER_SECURITY_ANALYTICS
      },
    };
  },
};
</script>
